export enum QuestionType {
  'MultipleChoice' = 'MultipleChoice',
  'MultipleResponse' = 'MultipleResponse',
  'Programming' = 'Programming',
  'TextResponse' = 'TextResponse',
  'FileUpload' = 'FileUpload',
  'Comprehension' = 'Comprehension',
  'Scribing' = 'Scribing',
  'VoiceResponse' = 'VoiceResponse',
  'ForumPostResponse' = 'ForumPostResponse',
  'RubricBasedResponse' = 'RubricBasedResponse',
}
